import React from "react";
import {PrivacyPolicy} from "../components/PrivacyPolicy";
import {Helmet} from "react-helmet-async";

export default function PrivacyPolicyPage() {
    return (
        <>
            <Helmet prioritizeSeoTags>
                <title>Privacy Policy — Codebuddy AI</title>
                <link rel="canonical" key="link-canonical" href="https://www.codebuddy.ca/privacy-policy"/>
                <meta property="og:title" name="og:title" key="og:title" content="Privacy Policy — Codebuddy AI"/>
                <meta property="og:url" name="og:url" key="og:url" content="https://www.codebuddy.ca/privacy-policy"/>
            </Helmet>
            <PrivacyPolicy/>
        </>
    );
}